import React from 'react';
import { Logo as WaitroseLogo } from '@johnlewispartnership/wtr-ingredients/ingredients/Logo/index.js';
import { useFeatureFlags } from '@johnlewispartnership/wtr-website-decisioner-client/express';
import { prideLogo, prideLogoSmall } from './svgLogos';

import styles from './Logo.module.scss';

export interface LogoProps {
  small?: boolean;
}

const Logo = ({ small = false }: LogoProps) => {
  const { showPrideLogo } = useFeatureFlags();

  if (small) {
    return showPrideLogo ? (
      prideLogoSmall
    ) : (
      <>
        <WaitroseLogo optimised className={styles.logoSmall} clearSpace={false} />
        <span className={styles.srOnly}>Visit Waitrose.com</span>
      </>
    );
  }

  return showPrideLogo ? (
    prideLogo
  ) : (
    <>
      <WaitroseLogo className={styles.logoRegular} clearSpace={false} />
      <span className={styles.srOnly}>Visit Waitrose.com</span>
    </>
  );
};

Logo.displayName = 'Logo';

export default Logo;
